import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Users } from "lucide-react";
import PageHero from "../components/PageHero";
import { fetchProjects } from "../lib/api";

export default function Progetti() {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("Tutti");

  useEffect(() => {
    fetchProjects().then(setProjects).catch(() => {});
  }, []);

  const cats = ["Tutti", "In corso", "Conclusi"];
  const filtered =
    filter === "Tutti"
      ? projects
      : filter === "In corso"
      ? projects.filter((p) => p.status === "in-corso")
      : projects.filter((p) => p.status === "concluso");

  return (
    <div data-testid="page-progetti">
      <PageHero
        eyebrow="Progetti speciali · 2021 — oggi"
        title="I progetti che"
        italic="costruiamo, insieme."
        subtitle="Iniziative didattiche, sociali e culturali realizzate sul territorio in collaborazione con enti pubblici, scuole, fondazioni e la Regione Emilia-Romagna."
      />

      <section className="py-16 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto">
        <div className="flex flex-wrap gap-2 mb-12" data-testid="project-filters">
          {cats.map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              data-testid={`project-filter-${cat.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-[11px] tracking-eyebrow px-4 py-2 rounded-sm border transition ${
                filter === cat
                  ? "bg-[#A3133A] text-white border-[#A3133A]"
                  : "bg-transparent text-[#A3133A] border-[#A3133A]/30 hover:border-[#A3133A]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="space-y-12">
          {filtered.map((p, idx) => (
            <Link
              to={`/progetti/${p.id}`}
              key={p.id}
              data-testid={`project-card-${p.id}`}
              className={`group grid grid-cols-1 lg:grid-cols-12 gap-px bg-[#A3133A]/15 border border-[#A3133A]/15 hover:border-[#A3133A]/40 transition-all`}
            >
              <div className={`lg:col-span-7 bg-[#FBFBF9] aspect-[16/10] lg:aspect-auto overflow-hidden ${idx % 2 ? "lg:order-2" : ""}`}>
                <img
                  src={p.immagine_copertina}
                  alt={p.titolo}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className={`lg:col-span-5 bg-[#FBFBF9] p-8 sm:p-10 flex flex-col justify-center ${idx % 2 ? "lg:order-1" : ""}`}>
                <div className="text-[10px] tracking-eyebrow text-[#A3133A] mb-3 flex items-center gap-3">
                  <span>{p.categoria}</span>
                  <span className="opacity-40">·</span>
                  <span className={p.status === "in-corso" ? "text-[#A3133A]" : "text-[#5C5C5C]"}>
                    {p.status === "in-corso" ? "In corso" : p.status === "in-programma" ? "In programma" : "Concluso"}
                  </span>
                </div>
                <h2 className="font-serif-display text-3xl sm:text-4xl text-[#1C1C1C] mb-3 leading-tight">{p.titolo}</h2>
                <div className="text-sm text-[#5C5C5C] italic mb-4">{p.periodo}</div>
                <p className="text-base text-[#5C5C5C] leading-relaxed mb-5">{p.estratto}</p>

                <div className="space-y-2 text-[12px] text-[#5C5C5C] mb-6">
                  <div className="flex items-start gap-2">
                    <MapPin size={12} className="mt-1 text-[#A3133A] shrink-0" />
                    <span>{p.luogo}</span>
                  </div>
                  {p.partners && p.partners.length > 0 && (
                    <div className="flex items-start gap-2">
                      <Users size={12} className="mt-1 text-[#A3133A] shrink-0" />
                      <span>{p.partners.join(" · ")}</span>
                    </div>
                  )}
                </div>

                <span className="text-[12px] tracking-eyebrow text-[#A3133A] inline-flex items-center gap-2 link-underline self-start">
                  Scopri il progetto <ArrowRight size={12} />
                </span>
              </div>
            </Link>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20 text-[#5C5C5C]" data-testid="projects-empty">
            Nessun progetto in questa categoria.
          </div>
        )}
      </section>
    </div>
  );
}
